export const GET_WALLET_REQUEST = "GET_WALLET_REQUEST";
export const GET_WALLET_SUCCESS = "GET_WALLET_SUCCESS";
export const GET_WALLET_FAILURE = "GET_WALLET_FAILURE";
export const DELETE_WALLET_ITEM = "DELETE_WALLET_ITEM";
export const EMPTY_WALLET_ITEMS = "EMPTY_WALLET_ITEMS";